import { Action } from "VSS/Flux/Action";
import Contracts = require("TFS/DistributedTask/Contracts");
import { ActionsHubBase, IEmptyActionPayload } from "DistributedTaskControls/Common/Actions/Base";
import Model = require("DistributedTaskControls/SharedControls/SharedProjectsPanel/SharedProjectsPanelModel");

export class SharedProjectsPanelActions extends ActionsHubBase {

    public initialize(): void {
        this._sharedProjectsData = new Action<Model.SharedProjectsPanelData>();
        this._updateSharedProjects = new Action<Contracts.ProjectReference[]>();
        this._removedSharedProject = new Action<Contracts.ProjectReference>();
        this._addedSharedProject = new Action<Contracts.ProjectReference>();
        this._updateError = new Action<string>();
        this._handlePanelClose = new Action<IEmptyActionPayload>();
    }

    public static getKey(): string {
        return this._sharedProjectsPanelActionsKey;
    }

    public get sharedProjectsData(): Action<Model.SharedProjectsPanelData> {
        return this._sharedProjectsData;
    }

    public get updateSharedProjects(): Action<Contracts.ProjectReference[]> {
        return this._updateSharedProjects;
    }

    public get removedSharedProject(): Action<Contracts.ProjectReference> {
        return this._removedSharedProject;
    }

    public get addedSharedProject(): Action<Contracts.ProjectReference> {
        return this._addedSharedProject;
    }

    public get updateError(): Action<string> {
        return this._updateError;
    }

    public get handlePanelClose(): Action<IEmptyActionPayload> {
        return this._handlePanelClose;
    }

    private _sharedProjectsData: Action<Model.SharedProjectsPanelData>;
    private _updateSharedProjects: Action<Contracts.ProjectReference[]>;
    private _removedSharedProject: Action<Contracts.ProjectReference>;
    private _addedSharedProject: Action<Contracts.ProjectReference>;
    private _updateError: Action<string>;
    private _handlePanelClose: Action<IEmptyActionPayload>;
    private static _sharedProjectsPanelActionsKey: string = "SharedProjectsPanelActionsKey";
}


